import React from "react";
import { List, Spin, Empty } from "antd";

/**
 * Lista reutilizable basada en List.Item.Meta.
 * Props:
 *  - dataSource: array de items.
 *  - loading: muestra Spin centrado.
 *  - vacioTexto: texto del Empty cuando no hay items.
 *  - avatar(item): opcional (avatar/ícono).
 *  - titulo(item): del título.
 *  - descripcion(item): la descripción.
 *  - acciones(item, index): array para las acciones a la derecha.
 *  - onItemClick(item, index): si se pasa, el item es clickeable.
 *  - rowKey: campo para la key (default "_id").
 *  - itemStyle / style: estilos opcionales.
 */
const ListaItems = ({
  dataSource = [],
  loading = false,
  vacioTexto = "Sin datos",
  avatar,
  titulo,
  descripcion,
  acciones,
  onItemClick,
  rowKey = "_id",
  itemStyle,
  style,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 20 }}>
        <Spin />
      </div>
    );
  }
  if (!dataSource.length) {
    return <Empty description={vacioTexto} />;
  }
  return (
    <List
      style={style}
      dataSource={dataSource}
      renderItem={(item, index) => (
        <List.Item
          key={item?.[rowKey] ?? index}
          style={{ cursor: onItemClick ? "pointer" : undefined, ...itemStyle }}
          onClick={onItemClick ? () => onItemClick(item, index) : undefined}
          actions={acciones ? acciones(item, index) : undefined}
        >
          <List.Item.Meta
            avatar={avatar ? avatar(item) : undefined}
            title={titulo ? titulo(item) : undefined}
            description={descripcion ? descripcion(item) : undefined}
          />
        </List.Item>
      )}
    />
  );
};

export default ListaItems;
